var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41138_35136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#4E5968"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41138_35136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 10.6667C8.83332 10.6667 9.54166 10.375 10.125 9.79166C10.7083 9.20832 11 8.49999 11 7.66666C11 6.83332 10.7083 6.12499 10.125 5.54166C9.54166 4.95832 8.83332 4.66666 7.99999 4.66666C7.16666 4.66666 6.45832 4.95832 5.87499 5.54166C5.29166 6.12499 4.99999 6.83332 4.99999 7.66666C4.99999 8.49999 5.29166 9.20832 5.87499 9.79166C6.45832 10.375 7.16666 10.6667 7.99999 10.6667ZM7.99999 9.46666C7.49999 9.46666 7.07499 9.29166 6.72499 8.94166C6.37499 8.59166 6.19999 8.16666 6.19999 7.66666C6.19999 7.16666 6.37499 6.74166 6.72499 6.39166C7.07499 6.04166 7.49999 5.86666 7.99999 5.86666C8.49999 5.86666 8.92499 6.04166 9.27499 6.39166C9.62499 6.74166 9.79999 7.16666 9.79999 7.66666C9.79999 8.16666 9.62499 8.59166 9.27499 8.94166C8.92499 9.29166 8.49999 9.46666 7.99999 9.46666ZM7.99999 12.6667C6.5111 12.6667 5.15277 12.2667 3.92499 11.4667C2.69721 10.6667 1.72777 9.6111 1.01666 8.29999C0.961102 8.19999 0.919435 8.09721 0.891658 7.99166C0.86388 7.8861 0.849991 7.77777 0.849991 7.66666C0.849991 7.55555 0.86388 7.44721 0.891658 7.34166C0.919435 7.2361 0.961102 7.13332 1.01666 7.03332C1.72777 5.72221 2.69721 4.66666 3.92499 3.86666C5.15277 3.06666 6.5111 2.66666 7.99999 2.66666C9.48888 2.66666 10.8472 3.06666 12.075 3.86666C13.3028 4.66666 14.2722 5.72221 14.9833 7.03332C15.0389 7.13332 15.0805 7.2361 15.1083 7.34166C15.1361 7.44721 15.15 7.55555 15.15 7.66666C15.15 7.77777 15.1361 7.8861 15.1083 7.99166C15.0805 8.09721 15.0389 8.19999 14.9833 8.29999C14.2722 9.6111 13.3028 10.6667 12.075 11.4667C10.8472 12.2667 9.48888 12.6667 7.99999 12.6667Z",
    fill: "#4E5968"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/ShowPassword.9861c6a8323207228ddc6064c96521c1.svg";
export { ForwardRef as ReactComponent };